import { EEndReason } from 'src/types/followup'
import { TPatientMedAlert } from 'src/types/med-alert'
import { EConvocationDateSetBy, TPatientMedEventMetadata } from 'src/types/med-event'
import { TLabel } from 'src/types/locales'
import { EPatientGender, TPatientConsent } from 'src/types/patient'
import { EUserTitle } from 'src/types/user'
import { TPatientFollowupDocument } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/use-patient-followup-documents.hook'

export enum EPlanningColumns {
  ID = 'ID',
  PATIENT = 'PATIENT',
  MED_EVENT = 'MED_EVENT',
  CONVOCATION = 'CONVOCATION',
  MEDICAL_STAFF_MEMBER = 'MEDICAL_STAFF_MEMBER',
  PATIENT_MED_ALERT = 'PATIENT_MED_ALERT',
  MEDICAL_TEAM_COMMENT = 'MEDICAL_TEAM_COMMENT',
  DOCUMENTS = 'DOCUMENTS',
  ACTIONS = 'ACTIONS',
}

export type TSearchPlanningTab = Omit<TPlanningTab, 'tabPosition' | 'label'> & {
  id: 0
}

export type TPlanningTab = {
  id: number
  migrationNote?: string | null
  label: string
  relativeRangeOfDays: [number, number]
  followupIdsFilter?: number[] | null
  medEventIdsFilter?: number[] | null
  medicalStaffMemberIdsFilter?: (number | null)[] | null
  locationIdsFilter?: number[] | null
  columns: EPlanningColumns[]
  tabPosition: number
  /** The "all" tab is stored like a regular tab, but its position is fixed and only its columns can be updated. */
  isAllTab?: boolean
}

export type TPlanningFilters = {
  relativeDaysFromToday: number
  followupIds?: number[]
  medEventIds?: number[]
  medicalStaffMemberIds?: (number | null)[]
  locationIds?: number[]
}

export type TPlanningPatientMedEvent = {
  id: number
  date: string | Date
  convocationDate?: string | null
  convocationDateSetBy?: EConvocationDateSetBy | null
  metadata: TPatientMedEventMetadata | null
  Patient: TPlanningPatient
  MedicalStaffMember: TPlanningMedicalStaffMember | null
  PatientFollowup: TPlanningPatientFollowup
  MedEvent: TPlanningMedEvent
  PatientMedAlerts: TPatientMedAlert[]
}
export type TPlanningPatient = {
  id: number
  remoteId: string | null
  firstname: string
  lastname: string
  gender: EPatientGender
  phone: string
  birthdate: string | null
  isPhoneValid: boolean
  hasCaregiver: boolean
  isTestAccount: boolean
  medicalTeamCommentCount: number
  PatientConsent?: TPatientConsent
}
export type TPlanningMedicalStaffMember = {
  id: number
  firstname: string
  lastname: string
  civility: EUserTitle
}
export type TPlanningPatientFollowup = {
  id: number
  FollowupId: number
  endReason: EEndReason
  Followup?: {
    id: number
    intlName: TLabel
  }
  /** Only sent when the tab has the DOCUMENTS column and the user can view sensitive data. */
  documents?: TPatientFollowupDocument[]
}
export type TPlanningMedEvent = {
  id: number
  intlName: TLabel
}

export type PlanningTabFormValues = {
  id?: number
  label: string
  relativeRangeOfDays: [number, number]
  followupIdsFilter?: number[]
  medEventIdsFilter?: number[]
  medicalStaffMemberIdsFilter?: (number | null)[]
  locationIdsFilter?: number[]
  tabPosition: number
  columns: EPlanningColumns[]
}

export type PlanningAllTabFormValues = Pick<PlanningTabFormValues, 'columns'>

export type TPlanningPatientMedEventsResponse = {
  patientMedEvents: TPlanningPatientMedEvent[]
  patientMedEventsCount: number
  totalPages: number
}

export type TPatientMedEventsByRangeOfDays = {
  relativeDay: number
  hasPatientMedEvent: boolean
}[]

export enum EPlanningOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type TPlanningOrder = {
  orderBy: EPlanningColumns
  orderDirection: EPlanningOrderDirection
}

export type TPlanningPatientMedEventsRequest = {
  relativeDaysFromToday: number
  medEventIds?: number[] | null
  followupIds?: number[] | null
  medicalStaffMemberIds?: (number | null)[] | null
  locationIds?: number[] | null
  columns: EPlanningColumns[]
  orderBy: EPlanningColumns
  orderDirection: EPlanningOrderDirection
  page: number
}
